var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"handle-bar flex-center"},[(_vm.$slots.icon)?_c('div',[_vm._t("icon")],2):_vm._e(),_c('div',{staticClass:"flex-grow"},[_vm._t("default")],2),(_vm.$slots.handle)?_c('div',{staticClass:"handle flex"},[_vm._t("handle")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }